import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import { client } from '../../api/client';
import { logEvent, EVENTS } from '../../lib/event-helper';

const reviewsAdapter = createEntityAdapter({
    selectId: review => review.re_id
});


const initialState = {
    all: reviewsAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    byPoi: reviewsAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    byUser: reviewsAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    newReview: {
        status: 'ilde',
        error: null
    },
    delete: {
        status: 'idle',
        error: null
    },
    reviewsCount: null,
    loadingMore: false,
    reviewBeingEdited: null
};

export const fetchPoiReviews = createAsyncThunk('reviews/fetchPoiReviews', async (poiId) => {
    const response = await client.get('/get_reviews/' + poiId);
    return response;
});

export const fetchAllReviews = createAsyncThunk('reviews/fetchAllReviews', async ({limit = 20, buffer = 0}) => {
    const response = await client.get(`/getReviews/0/${limit}/${buffer}`);
    return response;
});

export const addReview = createAsyncThunk('reviews/addReview', async ({userId, poiId, rating, review, reviewId}) => {
    const response = await client.post(
            `/send_review/${userId}/${poiId}/${rating}/${reviewId}`, {text: review});
    return response;
});

export const fetchUserReviews = createAsyncThunk('reviews/fetchUserReviews', async (userId) => {
    const response = await client.get('/getReviews/' + userId);
    return response;
});

export const deleteReview = createAsyncThunk('reviews/deleteReview', async (reviewId) => {
    const response = await client.get(`/delete_review/${reviewId}`);
    return response;
});

export const fetchCountReviews = createAsyncThunk('reviews/fetchCountReviews', async() => {
    const response = await client.get('/getCountReviews');
    return response;
});

const reviewsSlice = createSlice({
    name: 'reviews',
    initialState,
    reducers: {
        editedReview(state, action) {
            console.log('editedReview', action);
            state.reviewBeingEdited = action.payload;
        }
    },
    extraReducers: {
        [fetchPoiReviews.pending]: (state, action) => {
            state.byPoi.status = 'loading';
        },
        [fetchPoiReviews.fulfilled]: (state, action) => {
            state.byPoi.status = 'succeeded';

            reviewsAdapter.setAll(state.byPoi, action.payload);
        },
        [fetchPoiReviews.rejected]: (state, action) => {
            state.all.status = 'failed';
            state.all.error = action.payload;
        },
        [fetchAllReviews.pending]: (state, action) => {
            if (!action.meta.arg.buffer) {
                state.all.status = 'loading';
            } else {
                state.loadingMore = true;
            }
        },
        [fetchAllReviews.fulfilled]: (state, action) => {
            state.all.status = 'succeeded';
            if (!action.meta.arg.buffer) {
                reviewsAdapter.setAll(state.all, action.payload);
            } else {
                reviewsAdapter.upsertMany(state.all, action.payload);
                state.loadingMore = false;
            }
        },
        [fetchAllReviews.rejected]: (state, action) => {
            state.all.status = 'failed';
            state.all.error = action.payload;
        },
        [addReview.pending]: (state, action) => {
            state.newReview.status = 'loading';
        },
        [addReview.fulfilled]: (state, action) => {
            state.newReview.status = 'succeeded';
            
        },
        [addReview.rejected]: (state, action) => {
            state.newReview.status = 'failed';
            state.newReview.error = action.payload;
            state.byUser.status = 'idle';
        },
        [fetchUserReviews.pending]: (state, action) => {
            state.byUser.status = 'loading';
        },
        [fetchUserReviews.fulfilled]: (state, action) => {
            state.byUser.status = 'succeeded';
            reviewsAdapter.setAll(state.byUser, action.payload);
        },
        [fetchUserReviews.rejected]: (state, action) => {
            state.byUser.status = 'failed';
            state.byUser.error = action.payload;
        },
        [deleteReview.pending]: (state, action) => {
            state.delete.status = 'loading';
        },
        [deleteReview.fulfilled]: (state, action) => {
            state.delete.status = 'succeeded';
            state.byUser.status = 'idle';
            state.all.status = 'idle';
        },
        [deleteReview.rejected]: (state, action) => {
            state.delete.status = 'failed';
            state.delete.error = action.payload;
        },
        [fetchCountReviews.fulfilled]: (state, action) => {
            state.reviewsCount = action.payload;
        }
    }
});

export default reviewsSlice.reducer;
export const { editedReview } = reviewsSlice.actions;

export const {
    selectAll: selectPoiReviews,
    selectById: selectPoiReviewById,
    selectIds: selectPoiReviewIds
} = reviewsAdapter.getSelectors(state => state.reviews.byPoi);

export const {
    selectAll: selectAllReviews,
    selectById: selectReviewById,
    selectIds: selectAllReviewIds
} = reviewsAdapter.getSelectors(state => state.reviews.all);

export const {
    selectAll: selectUserReviews,
    selectById: selectUserReviewById,
    selectIds: selectUserReviewIds
} = reviewsAdapter.getSelectors(state => state.reviews.byUser);

